import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { UploadVaccinationComponent } from './upload-vaccination/upload-vaccination.component';
import { MatButton } from '@angular/material/button';

import { GooleAnalyticsEventsService } from 'src/app/core/services/goole-analytics-events.service';



@Component({
    selector: 'app-banner-notification',
    templateUrl: './banner-notification.component.html',
    styleUrls: ['./banner-notification.component.scss'],
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class BannerNotificationComponent implements OnInit {

  container;
  keepContainer: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, overlayContainer: OverlayContainer, private dialog: MatDialog, private googleAnalyticsEvents: GooleAnalyticsEventsService) {
    overlayContainer.getContainerElement().classList.add('broadcast-dialog_overlay');
    this.container = overlayContainer;
  }
  ngOnInit(): void {
  }

  onUpdate(): void {
    this.keepContainer = true;
    const dialogRef = this.dialog.open(UploadVaccinationComponent, {});
    const section = window.location.pathname.split('/').pop() || 'home';
    this.googleEvent(section, 'banner viewed vaccination record');
  }

  googleEvent(section: string, cardTitle: string) {
    this.googleAnalyticsEvents.eventEmitter(cardTitle, section, 'home', 10);
  }

  ngOnDestroy(): void {
    if (!this.keepContainer) {
      this.container.getContainerElement().classList.remove('broadcast-dialog_overlay');
    }
  }
}
